'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@radix-ui/react-popover/dist/index.cjs');
var React = require('react');

/**
 * Trigger wrapper component to control the visibility of the popover
 *
 * {@link https://aviary.fullscript.io/latest/components/popover-1-1/web-CwmN8Qt3 | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Popover/Trigger/Trigger.web.tsx | View in GitLab}
 *
 */ const Trigger = ({ children })=>{
    const ForwardedChild = /*#__PURE__*/ React.forwardRef((props, ref)=>{
        const newProps = {
            ...props,
            innerRef: ref
        };
        return /*#__PURE__*/ React.cloneElement(children, newProps);
    });
    ForwardedChild.displayName = "ForwardedChild";
    return /*#__PURE__*/ jsxRuntime.jsx(index.Trigger, {
        asChild: true,
        children: /*#__PURE__*/ jsxRuntime.jsx(ForwardedChild, {})
    });
};
Trigger.displayName = "Popover.Trigger";

exports.Trigger = Trigger;
//# sourceMappingURL=Trigger.web.cjs.map
